import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const hazardcategories = 
{
    namespaced: true,
    state: {
        hazardcategories: [],
        hazardcategory: {}
    },
    mutations: {
        SET_HAZARDCATEGORIES(state, data)
        {
            state.hazardcategories = data
        },
        SET_HAZARDCATEGORY(state, data)
        {
            state.hazardcategory = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'GHSHazardCategory', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_HAZARDCATEGORIES', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deleteHazardCategory ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updateHazardCategory({ commit },{id, data}){
            return axios
            .post(baseUrl+'GHSHazardCategory/updateHazardCategory/'+id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getHazardCategory ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewHazardCategory ({ commit }, data) {
            return axios
            .post(baseUrl+'GHSHazardCategory/addHazardCategory', data, { withCredentials: true })
            .then(res => {
                console.log("new hazard category added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default hazardcategories